export enum PRO_ACCOUNT_STATUS {
    LEAD = 'lead',
    APPLICANT = 'applicant',
    ACTIVE = 'active',
    SUSPENDED = 'suspended',
    VACATION = 'vacation'
}
